import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { Users } from '~src/userManagement/services/resources/Users';

import { getNoDefaultFilters } from './getDefaultFilters';

export const SearchUserDefinition: ExplorableItemDefinition = {
  itemType: 'searchuser',
  pluralName: Messages.users,
  singularName: Messages.user,
  emptyStateMessage: Messages.usersEmptyMessage,
  contentFilterKeys: [ContentFiltersKeys.search],
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['searchuser']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Users.instance.all().withExtraParams({
      'getItemCounts': true
    });
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
